/**
 * Vervit — global purchased-product catalog for verified reviews.
 * Syncs from server JSON, account DOM, and /account fetch.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'vrvPurchasedCatalog';
  var CATALOG_VERSION = '2';
  var CATALOG_VERSION_KEY = 'vrvPurchasedCatalogVersion';
  var EMAIL_STORAGE_KEY = 'vrvCheckoutEmail';
  var PHONE_STORAGE_KEY = 'vrvCheckoutPhone';
  var ACCOUNT_PATHS = [
    '/account',
    '/account?section_id=main-account',
    '/account?page=2',
    '/pages/rzp-account',
    '/pages/rzp-account?section_id=main',
    '/pages/rzp-account?page=2'
  ];

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  function pushUnique(list, value) {
    var next = String(value || '').trim();
    if (!next) return;
    if (list.indexOf(next) === -1) list.push(next);
  }

  function readCatalog() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function writeCatalog(catalog) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          ids: catalog.ids || [],
          handles: catalog.handles || [],
          titles: catalog.titles || [],
          updatedAt: Date.now()
        })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function mergeCatalogs() {
    var merged = { ids: [], handles: [], titles: [] };
    for (var i = 0; i < arguments.length; i += 1) {
      var catalog = arguments[i] || {};
      (catalog.ids || []).forEach(function (id) {
        pushUnique(merged.ids, String(id || '').trim());
      });
      (catalog.handles || []).forEach(function (handle) {
        pushUnique(merged.handles, normalizeText(handle));
      });
      (catalog.titles || []).forEach(function (title) {
        pushUnique(merged.titles, normalizeText(title));
      });
    }
    writeCatalog(merged);
    return merged;
  }

  function readServerCatalog() {
    var el = document.getElementById('vrv-server-purchase-catalog');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent || el.innerHTML || '{}');
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function catalogFromRazorpayDom(root) {
    var scope = root || document;
    var ids = [];
    var handles = [];
    var titles = [];

    scope.querySelectorAll('.vrv-order-card[data-vrv-product-ids]').forEach(function (card) {
      (card.getAttribute('data-vrv-product-ids') || '').split(',').forEach(function (id) {
        pushUnique(ids, String(id || '').trim());
      });
      (card.getAttribute('data-vrv-product-handles') || '').split(',').forEach(function (handle) {
        pushUnique(handles, normalizeText(handle));
      });
      (card.getAttribute('data-vrv-line-titles') || '').split('||').forEach(function (title) {
        pushUnique(titles, normalizeText(title));
      });
    });

    scope.querySelectorAll('.vrv-order-card__items-title').forEach(function (node) {
      pushUnique(titles, normalizeText(node.textContent || ''));
    });

    return { ids: ids, handles: handles, titles: titles };
  }

  function catalogFromDom(root) {
    var scope = root || document;
    var base = { ids: [], handles: [], titles: [] };
    var rzp = catalogFromRazorpayDom(scope);

    scope.querySelectorAll('.vrv-order-card[data-vrv-product-ids]').forEach(function (card) {
      (card.getAttribute('data-vrv-product-ids') || '').split(',').forEach(function (id) {
        pushUnique(base.ids, String(id || '').trim());
      });
      (card.getAttribute('data-vrv-product-handles') || '').split(',').forEach(function (handle) {
        pushUnique(base.handles, normalizeText(handle));
      });
      (card.getAttribute('data-vrv-line-titles') || '').split('||').forEach(function (title) {
        pushUnique(base.titles, normalizeText(title));
      });
    });

    scope.querySelectorAll('.vrv-order-card__items-title').forEach(function (node) {
      pushUnique(base.titles, normalizeText(node.textContent || ''));
    });

    rzp.handles.forEach(function (handle) {
      pushUnique(base.handles, handle);
    });
    rzp.titles.forEach(function (title) {
      pushUnique(base.titles, title);
    });

    return base;
  }

  function catalogFromHtml(html) {
    var ids = [];
    var handles = [];
    var titles = [];
    if (!html) return { ids: ids, handles: handles, titles: titles };

    var match;
    var idPattern = /data-vrv-product-ids="([^"]*)"/g;
    while ((match = idPattern.exec(html))) {
      match[1].split(',').forEach(function (id) {
        pushUnique(ids, String(id || '').trim());
      });
    }

    var handlePattern = /data-vrv-product-handles="([^"]*)"/g;
    while ((match = handlePattern.exec(html))) {
      match[1].split(',').forEach(function (handle) {
        pushUnique(handles, normalizeText(handle));
      });
    }

    var titlePattern = /data-vrv-line-titles="([^"]*)"/g;
    while ((match = titlePattern.exec(html))) {
      match[1].split('||').forEach(function (title) {
        pushUnique(titles, normalizeText(title));
      });
    }

    var visibleTitlePattern = /vrv-order-card__items-title[^>]*>([^<]+)</g;
    while ((match = visibleTitlePattern.exec(html))) {
      pushUnique(titles, normalizeText(match[1]));
    }

    return { ids: ids, handles: handles, titles: titles };
  }

  function titlesMatch(catalogTitles, productTitle) {
    var titleNorm = normalizeText(productTitle);
    if (!titleNorm) return false;

    return (catalogTitles || []).some(function (title) {
      if (!title) return false;
      if (title === titleNorm) return true;
      if (titleNorm.length >= 10 && titleNorm.indexOf(title) !== -1) return true;
      if (title.length >= 10 && title.indexOf(titleNorm) !== -1) return true;
      if (titleNorm.length > 20 && title.length > 20) {
        var shortA = titleNorm.slice(0, 20);
        var shortB = title.slice(0, 20);
        if (shortA === shortB) return true;
      }
      return false;
    });
  }

  function ownsProduct(catalog, productId, productHandle, productTitle) {
    if (!catalog) return false;
    var ids = catalog.ids || [];
    var handles = catalog.handles || [];
    var idStr = productId ? String(productId) : '';
    var handleStr = productHandle ? normalizeText(productHandle) : '';

    if (idStr && ids.indexOf(idStr) !== -1) return true;
    if (handleStr && handles.indexOf(handleStr) !== -1) return true;
    return titlesMatch(catalog.titles || [], productTitle);
  }

  function ownsProductStrict(catalog, productId, productHandle) {
    if (!catalog) return false;
    var ids = catalog.ids || [];
    var handles = catalog.handles || [];
    var idStr = productId ? String(productId) : '';
    var handleStr = productHandle ? normalizeText(productHandle) : '';

    if (idStr && ids.indexOf(idStr) !== -1) return true;
    if (handleStr && handles.indexOf(handleStr) !== -1) return true;
    return false;
  }

  function htmlLooksLikeOrdersPage(html, url) {
    if (!html) return false;
    var pageUrl = url || '';
    if (pageUrl.indexOf('/account/login') !== -1 || pageUrl.indexOf('/account/register') !== -1) {
      return false;
    }
    if (/customer_login|CustomerLogin|id="login"|vrv-auth__form/i.test(html)) return false;
    if (/vrv-order-card|vrv-orders-list|data-vrv-product-ids|order-history/i.test(html)) return true;
    if (pageUrl.indexOf('/account') !== -1 && pageUrl.indexOf('login') === -1) return true;
    return false;
  }

  function syncFromDom(root) {
    return mergeCatalogs(readCatalog(), readServerCatalog(), catalogFromDom(root));
  }

  function fetchAccountCatalogs() {
    var chain = Promise.resolve({ ids: [], handles: [], titles: [] });

    ACCOUNT_PATHS.forEach(function (path) {
      chain = chain.then(function (accumulated) {
        return fetch(path, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) {
            return res.text().then(function (html) {
              var finalUrl = res.url || path;
              if (!htmlLooksLikeOrdersPage(html, finalUrl)) return accumulated;
              var parsed = catalogFromHtml(html);
              return {
                ids: accumulated.ids.concat(parsed.ids),
                handles: accumulated.handles.concat(parsed.handles),
                titles: accumulated.titles.concat(parsed.titles)
              };
            });
          })
          .catch(function () {
            return accumulated;
          });
      });
    });

    return chain.then(function (accumulated) {
      return mergeCatalogs(readCatalog(), readServerCatalog(), accumulated);
    });
  }

  var refreshPromise = null;

  function refreshPurchaseCatalog(options) {
    var opts = options || {};
    if (!opts.force && refreshPromise) return refreshPromise;

    refreshPromise = Promise.resolve()
      .then(function () {
        var merged = mergeCatalogs(readCatalog(), readServerCatalog(), catalogFromDom(document));
        if (
          !opts.force &&
          merged.ids.length + merged.handles.length + merged.titles.length > 0 &&
          !opts.network
        ) {
          return merged;
        }
        return fetchAccountCatalogs();
      })
      .finally(function () {
        refreshPromise = null;
      });

    return refreshPromise;
  }

  function userOwnsProduct(productId, productHandle, productTitle) {
    return ownsProduct(readCatalog(), productId, productHandle, productTitle);
  }

  function userOwnsProductStrict(productId, productHandle) {
    return ownsProductStrict(readCatalog(), productId, productHandle);
  }

  function getVerifyReviewApiUrl() {
    var root = document.querySelector('[data-lux-verify-api]');
    if (root) {
      var fromReview = root.getAttribute('data-lux-verify-api');
      if (fromReview) return fromReview;
    }
    var cfg = window.vrvPincodeConfig || {};
    if (cfg.verifyReviewApiUrl) return cfg.verifyReviewApiUrl;
    if (cfg.spinWebhookUrl) {
      return String(cfg.spinWebhookUrl).replace(/\/spin-event\/?$/, '/verify-review-purchase');
    }
    return 'https://vervit-discount-sync.rishika-35d.workers.dev/verify-review-purchase';
  }

  function getStoredCheckoutEmail() {
    try {
      return String(localStorage.getItem(EMAIL_STORAGE_KEY) || '').trim().toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function saveCheckoutIdentity(email, phone) {
    try {
      if (email) localStorage.setItem(EMAIL_STORAGE_KEY, String(email).trim().toLowerCase());
      if (phone) localStorage.setItem(PHONE_STORAGE_KEY, String(phone).trim());
    } catch (e) {
      /* ignore */
    }
  }

  function getSessionPhone() {
    var phone = '';
    try {
      phone = String(localStorage.getItem(PHONE_STORAGE_KEY) || '').trim();
    } catch (e) {
      phone = '';
    }
    if (!phone) {
      var el = document.getElementById('RazorpayMagicSSOConfig');
      if (el) {
        try {
          var cfg = JSON.parse((el.textContent || el.innerHTML || '').trim());
          phone = String(cfg.phone || '').trim();
        } catch (err) {
          /* ignore */
        }
      }
    }
    return phone;
  }

  function getSessionEmail() {
    var email = getStoredCheckoutEmail();
    if (email) return email;
    if (document.body) {
      email = String(document.body.getAttribute('data-vrv-customer-email') || '').trim();
    }
    if (!email) {
      var accountRoot = document.querySelector('[data-vrv-customer-email]');
      if (accountRoot) {
        email = String(accountRoot.getAttribute('data-vrv-customer-email') || '').trim();
      }
    }
    if (!email) {
      var el = document.getElementById('RazorpayMagicSSOConfig');
      if (el) {
        try {
          var cfg = JSON.parse((el.textContent || el.innerHTML || '').trim());
          email = String(cfg.email || '').trim();
        } catch (err) {
          /* ignore */
        }
      }
    }
    return email.toLowerCase();
  }

  async function fetchSessionEmailFromAccount() {
    var known = getSessionEmail();
    if (known) return known;

    var paths = ['/account', '/pages/rzp-account'];
    for (var i = 0; i < paths.length; i += 1) {
      try {
        var res = await fetch(paths[i], {
          credentials: 'same-origin',
          headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        });
        var html = await res.text();
        var match = html.match(/data-vrv-customer-email="([^"]+)"/i);
        if (match && match[1]) {
          return String(match[1]).trim().toLowerCase();
        }
      } catch (err) {
        /* try next */
      }
    }
    return '';
  }

  async function verifyPurchaseViaWorker(productId, productHandle, productTitle, email, phone) {
    var apiUrl = getVerifyReviewApiUrl();
    var sessionEmail = email || (await fetchSessionEmailFromAccount()) || getSessionEmail();
    var sessionPhone = phone || getSessionPhone();
    if (!apiUrl || (!sessionEmail && !sessionPhone)) return null;

    try {
      var res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: sessionEmail || '',
          phone: sessionPhone || '',
          product_id: productId || '',
          product_handle: productHandle || '',
          product_title: productTitle || ''
        })
      });
      var data = await res.json();
      if (!data || data.ok === false) return data;
      if (data.verified) {
        saveCheckoutIdentity(sessionEmail || data.email || '', sessionPhone);
        try {
          var catalog = readCatalog();
          if (productId) pushUnique(catalog.ids, String(productId));
          if (productHandle) pushUnique(catalog.handles, normalizeText(productHandle));
          if (productTitle) pushUnique(catalog.titles, normalizeText(productTitle));
          writeCatalog(catalog);
        } catch (err) {
          /* ignore */
        }
      }
      return data;
    } catch (err) {
      return null;
    }
  }

  function bootDomObserver() {
    if (!document.body || window.vrvPurchaseCatalogObserver) return;
    var timer = null;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        syncFromDom(document);
      }, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.vrvPurchaseCatalogObserver = observer;
  }

  function boot() {
    try {
      if (localStorage.getItem(CATALOG_VERSION_KEY) !== CATALOG_VERSION) {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.setItem(CATALOG_VERSION_KEY, CATALOG_VERSION);
      }
    } catch (e) {
      /* ignore */
    }

    mergeCatalogs(readCatalog(), readServerCatalog(), catalogFromDom(document));

    // Order cards only ever exist on the account/orders pages. Watching the
    // whole DOM (and rewriting localStorage after every mutation burst) on
    // every other page -- home, collections, PDP -- was pure overhead.
    var onAccountPage = /^\/account|^\/pages\/rzp-account/.test(window.location.pathname);
    if (onAccountPage || document.querySelector('.vrv-order-card')) {
      bootDomObserver();
    }

    if (onAccountPage) {
      refreshPurchaseCatalog({ force: true, network: true });
      [800, 2000, 4000, 7000, 12000].forEach(function (delay) {
        window.setTimeout(function () {
          syncFromDom(document);
        }, delay);
      });
    }
  }

  window.vrvSyncPurchaseCatalog = syncFromDom;
  window.vrvRefreshPurchaseCatalog = refreshPurchaseCatalog;
  window.vrvUserOwnsProduct = userOwnsProduct;
  window.vrvUserOwnsProductStrict = userOwnsProductStrict;
  window.vrvReadPurchaseCatalog = readCatalog;
  window.vrvGetSessionEmail = getSessionEmail;
  window.vrvGetSessionPhone = getSessionPhone;
  window.vrvSaveCheckoutIdentity = saveCheckoutIdentity;
  window.vrvVerifyReviewPurchase = verifyPurchaseViaWorker;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
